import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// Ensure axios is configured as early as possible (before any components mount)
const apiBaseUrl = process.env.REACT_APP_baseUrl || "http://localhost:8100/api";
axios.defaults.baseURL = apiBaseUrl;

// Request interceptor to add Authorization header
axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor to handle authentication failures
axios.interceptors.response.use(
  function (response) {
    const url = response.config?.url || "";
    const isPublicPath = 
      url.includes("/forum-settings/public") ||
      window.location.pathname.includes("/login") ||
      window.location.pathname.includes("/forgot-password") ||
      window.location.pathname.includes("/privacy-policy") ||
      window.location.pathname.includes("/terms-and-conditions");

    if (response.data && response.data.authentication === false && !isPublicPath) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      window.location.href = "/login";
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
